import client from '../client';
import * as loginMutations from "../mutations/login";

export function submitUser(success, error, user, pass, force = false) {
    client.mutate({
        variables: { user, pass },
        mutation: loginMutations.login,
    })
    .then(success)
    .catch(error);
}



// WEBPACK FOOTER //
// ./src/graphql/actions/user.js